function prvtmouse(){

  const $el = $('.prvtmouse')

  let active = false
  let oldActive = false
  function scroll(){
    active = true
    update()
  }
  function scrollend(){
    active = false
    update()
  }
  function update(){
    if (active === oldActive) return
    oldActive = active
    $el.toggleClass('js-active', active)
  }

  bus.on('scroll', scroll)
  bus.on('scrollend', scrollend)
}
export default prvtmouse